<template>
  <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
    layout='inline'>
    <a-form-item label="" name='keyword'>
      <a-input-group compact :style="{width:'360px'}">
        <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
          <a-select-option value="product_name">商品名称</a-select-option>
          <a-select-option value="product_sn">商品编号</a-select-option>
        </a-select>
        <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
      </a-input-group>
    </a-form-item>
    <a-form-item label="时间筛选" name='time'>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
    </a-form-item>
     <a-form-item label="异常数量" name="sort">
        <a-select v-model:value="search.sort">
          <a-select-option value="DESC">从大到小排序</a-select-option>
          <a-select-option value="ASC">从小到到排序</a-select-option>
        </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <p class="p-b-20">总异常扫码数量：{{allNum}}</p>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
    <template v-slot:action="{ record }">
      <a v-has:antiAuditWarningLog="()=> {$router.push('/antiFleeingGoods/marketAudit/warningDetails?type=goods&id='+record.product_sn+'&name='+record.product_name)}"
        href="javascript:;">查看全部记录</a>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import { fleeingWarningProduct } from "@/api/antiFleeing";
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    page: 1,
    limit: 10,
    key_type: "product_name",
    keyword: "",
    sort:'DESC'
  };
  export default {
    components: {},
    setup() {
      const state = reactive({
        time: []
      });
      let columns = [
        {
          title: "商品编号",
          dataIndex: "product_sn",
          key: "product_sn",
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
        },
        {
          title: "商品规格",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          customRender:({record})=>{
            return record.product_sku_name ? record.product_sku_name:'单规格'
          } 
        },
        {
          title: "异常扫码数量",
          dataIndex: "scan_ex_num",
          key: "scan_ex_num",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        allNum,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        allNum,
        pageSearchChange,
        listLoading,
      };

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(fleeingWarningProduct, search.value);
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime
      };
    },
  };
</script>